// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_149d12', '__Lato_Fallback_149d12'"},"className":"__className_149d12","variable":"__variable_149d12"};